import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';

const root = document.getElementById('root');

if (root.hasChildNodes()) {
  hydrateRoot(
    root,
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
} else {
  createRoot(root).render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
}